import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-nested-input-view',
  templateUrl: './nested-input-view.component.html',
  styleUrls: ['./nested-input-view.component.css']
})
export class NestedInputViewComponent implements OnInit {

  @Input() record: any;
  @Input() field: any;
  @Input() layoutMode: 'horizontal'; 

  // Make Array available in template
  Array = Array;

  constructor() { }

  ngOnInit(): void {
    // Fix corrupted color data if necessary (objects instead of strings)
    if ((this.field.key === 'colors' || this.field.key === 'colorStrings') && 
        this.record[this.field.key] && 
        Array.isArray(this.record[this.field.key])) {
      
      this.record[this.field.key] = this.record[this.field.key].map((item: any) => {
        // If item is an object with a 'color' property, extract the color value
        if (typeof item === 'object' && item !== null && 'color' in item) {
          return item.color;
        }
        // Otherwise, return as-is (already a string)
        return item;
      });
    }
  }

  getObjectKeys(obj: any): string[] {
    if (!obj || typeof obj !== 'object') {
      return [];
    }
    return Object.keys(obj).filter(key => key !== '_id' && key !== 'id');
  }

  getDisplayValue(value: any): any {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return value.name || value.displayName || value.internalName || value._id;
    }
    return value;
  }

  shouldShowNestedData(): boolean {
    if (this.field.key === 'qualityLevelMultipliers') {
      return true;
    }
    
    const fieldData = this.record[this.field.key];
    if (!fieldData || !Array.isArray(fieldData) || fieldData.length === 0) {
      return false;
    }
    
    const firstItem = fieldData[0];
    return firstItem && typeof firstItem === 'object' && !Array.isArray(firstItem);
  }

}
